import { useEffect } from 'react';

import Spinner from 'src/app/components/Elements/Spinner';

import type { MultiReferralPromo } from '../constants';

import type { PropsFromRedux } from './container';

interface RedirectToPromoProps extends PropsFromRedux {
  promoCode: string;
  multiReferralPromoCode?: MultiReferralPromo;
}

export const RedirectToPromoPageRenderer = ({
  redirectToLoggedInHome,
  isLoggedIn,
  redirectToPromoPage,
  promoCode,
  multiReferralPromoCode,
}: RedirectToPromoProps) => {
  useEffect(() => {
    // Product request to redirect from /{promoCode} to /l/promoCode
    if (isLoggedIn) {
      redirectToLoggedInHome();
    } else {
      redirectToPromoPage(promoCode, multiReferralPromoCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Spinner centered />;
};
